export function emptyFunction() {
  return
}

export function blurPlaceholder(width: number, height: number) {
  return `https://singlecolorimage.com/get/979797/${width}x${height}`
}
